import React from 'react';
import styled from 'styled-components';

const StyledFormHelperText = styled.div`
    color: rgb(223, 53, 44);
    font-size: 16px;
    text-align: right;
    font-weight: 600;
    height: 21px;
`;

export interface FormHelperTextProps {
    className?: string;
    [props: string]: any;
}

const FormHelperText: React.FC<FormHelperTextProps> = ({ className, children, ...props }) => {
    return (
        <StyledFormHelperText {...props} className={className}>
            {children}
        </StyledFormHelperText>
    );
};

export default FormHelperText;
